import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "add",
  "use": "add-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\" id=\"add\">\n    <g fill=\"none\">\n        <circle fill=\"#027BF3\" cx=\"7\" cy=\"7\" r=\"7\" />\n        <path d=\"M7 4v6m3-3H4\" stroke=\"#FFF\" stroke-width=\"1.5\" stroke-linecap=\"square\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol